<template>
	<sf-search-layout>
		<el-row :gutter="20">
			<el-col :span="4">
				<sf-select-group
					:label="getMessage_('SWCC000247')"
					:inputValue="plantCd_"
					:options="plants_"
					:onChange="value => onChange({ key: 'plantCd', value })"
				/>
			</el-col>
			<el-col :span="4">
				<sf-select-group
					:label="getMessage_('SWCC000255')"
					:inputValue="pgmId_"
					:options="pgmIds_"
					:onChange="value => onChange({ key: 'pgmId', value })"
				/>
			</el-col>
			<el-col :span="4">
				<sf-select-group
					:label="getMessage_('SWCC000284')"
					:inputValue="procId_"
					:options="procIds_"
					:onChange="value => onChange({ key: 'procId', value })"
				/>
			</el-col>
		</el-row>
		<template slot="button">
			<sf-button v-if="isButton_(scrId, 'CR')" line :onClick="findAllProcesses"
				><i class="icon-sf-search"></i>{{ getMessage_('SWCC000244') }}</sf-button
			>
		</template>
	</sf-search-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/DaemonProcessManagement/store/helpers';
import { utils } from '@sfaas/util';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		...utils,
		onChange({ key, value }) {
			this.DEFAULT_ASSIGN({
				key: 'searchParams',
				value: {
					...this.searchParams,
					[key]: value
				}
			});
		},
		findAllProcesses() {
			this.$sf_toggleLoading(true);
			this.fetchProcesses_({ plantCd: this.user.plantCd, urlSearchParams: this.urlSearchParams_ }).finally(() =>
				this.$sf_toggleLoading(false)
			);
		}
	},
	created() {
		this.$sf_toggleLoading(true);
		this.fetchPlants_()
			.then(() => this.fetchPgmIds_({ plantCd: this.user.plantCd }))
			.then(() => this.DEFAULT_ASSIGN({ key: 'searchParams', value: { ...this.searchParams, plantCd: this.user.plantCd } }))
			.finally(() => this.$sf_toggleLoading(false));
	},
	watch: {
		// TODO
		pgmId_() {
			this.$sf_toggleLoading(true);
			this.fetchProcIdsByPgmId_({ plantCd: this.user.plantCd, pgmId: this.pgmId_ })
				.then(() => this.fetchProcesses_({ plantCd: this.user.plantCd, urlSearchParams: this.urlSearchParams_ }))
				.finally(() => this.$sf_toggleLoading(false));
		},
		procId_() {
			this.$sf_toggleLoading(true);
			this.fetchProcesses_({ plantCd: this.user.plantCd, urlSearchParams: this.urlSearchParams_ }).finally(() =>
				this.$sf_toggleLoading(false)
			);
		}
	}
};
</script>

<style langType="scss"></style>
